import { LocationType, useFrontendSubscriptionStatus } from '@cmctechnology/webinvest-store-frontend';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { subscribeAccounts, unsubscribeAccounts } from './actions';
import { ACCOUNT_API_NAMES } from './apis';
import { AccountStore, ACCOUNT_STORE_NAME } from './store';

type IStore = ReturnType<typeof AccountStore.getState>;

export const useSubscribeAccounts = (location: LocationType) => {
  const dispatch = useDispatch();
  const accounts = useSelector((store: IStore) => store[ACCOUNT_STORE_NAME].account);
  const { polling, error, fetching } = useFrontendSubscriptionStatus(ACCOUNT_STORE_NAME, ACCOUNT_API_NAMES.TradingAccountsGet3);

  useEffect(() => {
    dispatch<any>(subscribeAccounts(location));
    return () => {
      dispatch<any>(unsubscribeAccounts(location));
    };
  }, []);

  return {
    loading: fetching && Object.keys(accounts).length === 0,
    polling,
    error,
    data: accounts,
    fetching
  };
};
